export default class FilterDrawer {
  constructor(component) {
    this.dom = {
      $component: component,
      $filterToggle: document.querySelectorAll('.js-filterToggle'),
      $filterUnderlay: document.querySelector('.js-FilterUnderlay'),
      $filterContainer: document.querySelector('.js-filterContainer'),
    }
    this.state = {
      filterOpen: false,
      filterOpenClass: 'openFilter',
      underlayActiveClass: 'isActive',
    }
    this.toggleFilterHandler = this.toggleFilter.bind(this)

    this.mount()
    this.bindToWindow()
  }

  mount() {
    const { dom } = this
    dom.$filterToggle.forEach($toggle => $toggle.addEventListener('click', this.toggleFilterHandler))
  }

  toggleFilter() {
    const { dom, state } = this

    if (state.filterOpen) {
      dom.$component.setAttribute('aria-hidden', 'true')
      dom.$component.setAttribute('aria-expanded', 'false')
      dom.$filterContainer.classList.remove(state.filterOpenClass)
      dom.$filterUnderlay.classList.remove(state.underlayActiveClass)
      state.filterOpen = false
    } else {
      dom.$component.setAttribute('aria-hidden', 'false')
      dom.$component.setAttribute('aria-expanded', 'true')
      dom.$filterContainer.classList.add(state.filterOpenClass)
      dom.$filterUnderlay.classList.add(state.underlayActiveClass)
      state.filterOpen = true
    }
  }

  bindToWindow() {
    window.theme = window.theme || {}
    window.theme.FilterDrawer = this
  }
}
